<!-- 板材 -->
<template>
  <BaseFormItem2
    class="board"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :fillTips="fillTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
    :isShake="isShake"
  >
    <div class="board__content">
      <RadioTable2
        :value="val.board_brand ? `${val.board_brand}_${val.board_tg}_${val.board_model}` : ''"
        radioKey="board_brand_tg"
        radioLabel="#"
        :showExpand="true"
        :isError="isError"
        :loading="loading"
        :columns="columns"
        :tableData="options"
        @change="handleRowClick"
      >
        <template v-slot:board_brand="{ row }">
          <span>
            {{ row.board_brand.name }}
            <a 
              v-if="row.describe_pdf_url"
              class="board__table__pdf"
              target="_blank"
              :href="row.describe_pdf_url"
              @click.stop
            >
              <img src="@@/assets/img/icons/icon_pdf.png" />
            </a>
          </span>
        </template>
      </RadioTable2>
    </div>
  </BaseFormItem2>
</template>

<script>
import RadioTable2 from '@@/components/radioTable/index2'

import { getALUFields } from '@@/utils/getFields'

export default {
  props: {
    // 板材品牌
    board_brand: {
      type: String,
      default: ''
    },
    // TG值
    board_tg: {
      type: String,
      default: ''
    },
    // 型号
    board_model: {
      type: String,
      default: ''
    },
    // 板材展示(前端字段)
    view_board: {
      type: String,
      default: ''
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RadioTable2
  },
  data() {
    return {
      loading: false,
      val: {
        board_brand: this.board_brand,
        board_tg: this.board_tg,
        board_model: this.board_model,
        view_board: ''
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
      isShake: false, // 是否抖动两下
      columns: [
        { label: '板材品牌', prop: 'board_brand', slot: 'board_brand', minWidth: 80 },
        { label: '型号', prop: 'board_model', formatter: row => row.board_model.name },
        { label: 'TG值', prop: 'board_tg', formatter: row => row.board_tg.name },
        { label: '指定板材费', prop: 'specific_fee', formatter: row => row.specific_fee.name }
      ],
      // 数据格式与FR-4接口返回的保持一致，以防后续需要改成接口获取
      options: [
        {
          board_brand_tg: '国纪_TG150_1060',
          board_brand: { name: '国纪', value: '国纪' },
          board_tg: { name: 'TG150', value: 'TG150' },
          board_model: { name: '1060', value: '1060' },
          specific_fee: { name: '不加价', value: '' },
        },
        {
          board_brand_tg: '国纪_TG150_3003',
          board_brand: { name: '国纪', value: '国纪' },
          board_tg: { name: 'TG150', value: 'TG150' },
          board_model: { name: '3003', value: '3003' },
          specific_fee: { name: '+15元/㎡', value: '' },
        },
        {
          board_brand_tg: '国纪_TG150_5052',
          board_brand: { name: '国纪', value: '国纪' },
          board_tg: { name: 'TG150', value: 'TG150' },
          board_model: { name: '5052', value: '5052' },
          specific_fee: { name: '+30元/㎡', value: '' },
        },
      ]
    }
  },
  computed: {
    fields() {
      return getALUFields('board')
    },
    // 是否显示未填写样式
    fillTips() {
      const { board_brand } = this.val
      return !board_brand
    }
  },
  watch: {
    board_brand(board_brand) {
      this.val.board_brand = board_brand
    },
    board_tg(board_tg) {
      this.val.board_tg = board_tg
    },
    board_model(board_model) {
      this.val.board_model = board_model
    },
  },
  mounted() {
    // 默认选中第一个
    this.$nextTick(() => {
      this.handleRowClick(this.options[0])
    })
  },
  methods: {
    handleEmit() {
      for (let [key, value] of Object.entries(this.val)) {
        this.$emit(`update:${key}`, value)
      }
      this.isShowError(false)
    },
    handleRowClick(row) {
      const { board_brand, board_tg, board_model } = row
      this.val.board_brand = board_brand.value
      this.val.board_tg = board_tg.value
      this.val.board_model = board_model.value
      this.val.view_board = `${board_brand.name} ${board_model.name} ${board_tg.name}`
      this.handleEmit()
      this.$emit('change', { ...this.val })
    },
    // 当前选中行
    isCheckedRow(row) {
      const val = this.val
      return `${val.board_brand}_${val.board_tg}_${val.board_model}` === `${row.board_brand.value}_${row.board_tg.value}_${row.board_model.value}`
    },
    // 是否显示错误提示样式
    isShowError(isError) {
      this.isError = isError
    },
    // 是否抖动两下
    isShowShake(isShake) {
      this.isShake = isShake
      const timer = setTimeout(() => {
        this.isShake = false
        clearTimeout(timer)
      }, 300)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';
.board__content {
  box-sizing: border-box;
  width: 590px;
  @include media($size: sm) {
    width: 590px;
  }
  @include media($size: md) {
    width: 660px;
  }
  @include media($size: lg) {
    width: 720px;
  }
  .board__table__pdf {
    img {
      vertical-align: text-top;
    }
  }
}
</style>